export const getDataId = (name) => name.replace(/([a-z])([A-Z])/g, '$1 $2').split(' ')[0];

export default getDataId;
